import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {MemberManagementService} from '../member-management.service';
import {AddInvitesRequestModel} from './app-invites.model';

@Component({
  selector: 'app-app-invites',
  templateUrl: './app-invites.component.html',
  styleUrls: ['./app-invites.component.less']
})
export class AppInvitesComponent implements OnInit {
  @Input() changeInvites: boolean;
  @Input() members: any;
  @Output() onClose = new EventEmitter<boolean>();
  count = 3;
  enabled = true;

  constructor(private service: MemberManagementService) {
  }

  ngOnInit() {
  }

  close(refresh) {
    this.onClose.emit(refresh);
  }

  save() {
    const component = this;
    this.enabled = false;
    const request = new AddInvitesRequestModel();
    for (const m of this.members) {
      request.members.push(m.id);
    }
    request.invites = this.count;
    this.service.addInvites(request).subscribe(
      (response) => {
        component.close(true);
      },
      (error) => {
        component.enabled = true;
      }
    );
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/members/member-management/member-actions/app-invites.component.ts